// filepath: src/pages/matrimony/components/sectionForms/PersonalEditForm.tsx
import React from "react";
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Input,
  Select,
} from "@chakra-ui/react";
import { commonInputProps, commonSelectProps } from "src/pages/matrimony/pages/matrimonyForm.ui";
import { FIELD_LABELS } from "src/utils/matrimonyFieldLabels";
import { MARITAL_STATUS_OPTIONS, RELIGION_OPTIONS } from "src/utils/matrimonyOptions";
import type { PersonalState } from "src/types/marriageProfileSectionEdit.types";
import type { BaseSectionFormProps } from "./sectionFormProps";

type Props = BaseSectionFormProps & { values: PersonalState };

const genderButton = (
  current: string | undefined,
  target: string,
  setField: (k: string, v: any) => void,
) => (
  <Button
    flex="1"
    variant="outline"
    borderRadius="12px"
    borderColor={current === target ? "#4A2C2A" : "rgba(108,117,125,0.3)"}
    bg={current === target ? "rgba(74,44,42,0.06)" : "#F8F9FA"}
    color={current === target ? "#4A2C2A" : "#6C757D"}
    _hover={{ bg: "rgba(74,44,42,0.06)" }}
    onClick={() => setField("gender", target)}
  >
    {target}
  </Button>
);

const PersonalEditForm: React.FC<Props> = ({ values, errors, setField }) => (
  <>
    <FormControl isInvalid={!!errors.dob}>
      <FormLabel>{FIELD_LABELS.DATE_OF_BIRTH}</FormLabel>
      <Input
        {...commonInputProps}
        type="date"
        max={new Date().toISOString().split("T")[0]}
        value={values.dob || ""}
        onChange={(e) => setField("dob", e.target.value)}
      />
      <FormErrorMessage>{errors.dob}</FormErrorMessage>
    </FormControl>

    <FormControl isInvalid={!!errors.gender} isRequired>
      <FormLabel>{FIELD_LABELS.GENDER}</FormLabel>
      <HStack spacing={3} w="full">
        {genderButton(values.gender, "Male", setField)}
        {genderButton(values.gender, "Female", setField)}
      </HStack>
      <FormErrorMessage>{errors.gender}</FormErrorMessage>
    </FormControl>

    <FormControl isInvalid={!!errors.maritalStatus}>
      <FormLabel>{FIELD_LABELS.MARITAL_STATUS}</FormLabel>
      <Select
        {...commonSelectProps}
        value={values.maritalStatus || ""}
        onChange={(e) => setField("maritalStatus", e.target.value)}
        placeholder="Select your marital status"
      >
        {MARITAL_STATUS_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </Select>
      <FormErrorMessage>{errors.maritalStatus}</FormErrorMessage>
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.CASTE_DETAILS}</FormLabel>
      <Input
        {...commonInputProps}
        value={values.casteDetails || ""}
        onChange={(e) => setField("casteDetails", e.target.value)}
        placeholder="Enter caste details"
      />
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.RELIGION}</FormLabel>
      <Select
        {...commonSelectProps}
        value={values.religion || ""}
        onChange={(e) => setField("religion", e.target.value)}
        placeholder="Select religion"
      >
        {RELIGION_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>{opt.label}</option>
        ))}
      </Select>
    </FormControl>
  </>
);

export default PersonalEditForm;
